import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../fetchData";





export const useMyRaisedTicket = (filters) => {
    return useQuery({
        queryKey: ["tickets/my-raised", filters],
        queryFn: () => fetchData("tickets/my-raised", filters),

    });
};

export const useGetAssignedTicket = (filters) => {
    return useQuery({
        queryKey: ["tickets/assigned", filters],
        queryFn: () => fetchData("tickets/assigned", filters),

    });
};

export const useGetTicketsByRole = (filters) => {
    return useQuery({
        queryKey: ["tickets/byRole", filters],
        queryFn: () => fetchData("tickets/byRole", filters),

    });
};

export const useGetTicketsChatsById = (id) => {
    return useQuery({
        queryKey: ["ticket-chat/messages", id],
        queryFn: () => fetchData(`ticket-chat/messages/${id}`),
         enabled: !!id,

    });
};

export const useGetAllLeaveRequests= () => {
    return useQuery({
        queryKey: ["trainer-leaves/all"],
        queryFn: () => fetchData(`trainer-leaves/all`),


    });
};

export const useGetAllTrainerLeaves= () => {
    return useQuery({
        queryKey: ["trainer-leaves/trainer"],
        queryFn: () => fetchData(`trainer-leaves/trainer`),


    });
};

export const useGetAllNodeZoneList= (filters) => {
    return useQuery({
        queryKey: ["zones-list",filters],
        queryFn: () => fetchData(`zones-list`,filters),
    });
};

export const useGetOrderHistory = (
  page = 1,
  limit = 10,
  search = ""
) => {
  return useQuery({
    queryKey: ["order-history", page, limit, search],
    queryFn: () =>
      fetchData(
        `v1/purchase/orders?page=${page}&limit=${limit}&search=${search}`
      ),
  });
};














